import AudioPlayer from "../components/audioPlayer";
import FormattedText from "../components/formattedText";
import { useContent } from "../data/useContent";

const AudioPage = () => {
  const { entries: audios, loading, error } = useContent("bbi", "audios");

  return (
    <>
      <div className="page-container audio-page-container">
        <div className="hero">
          <h1>Audio Messages</h1>
          <img
            src="https://d14n4fsapeewqj.cloudfront.net/audios/audio-hero.webp"
            alt="audio hero"
          />
        </div>
        <div className="sect2">
          {loading && <p>Loading audio messages…</p>}
          {error && <p>{error}</p>}
          {audios.map((audio) => (
            <div className="audio" id={audio.slug} key={audio.id}>
              <div className="details">
                <img src={audio.coverLandscape} alt="" />
                <p>
                  <FormattedText text={audio.description} />
                </p>
              </div>
              <AudioPlayer src={audio.audio} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AudioPage;